import styled from 'styled-components';

export const IconsContainer = styled.div`
  position: relative;
  width: 140px;
  height: 80px;
`;

export const IconWrapper = styled.div`
  position: absolute;
  border-radius: 64px;
  padding: 7px;
  box-shadow: ${({ theme }) => theme.boxShadow.block};
  background-color: ${({ theme }) => theme.styleguideColors.backgroundPrimary};

  &:first-child {
    left: 0;
    top: 0;
    z-index: 1;
  }

  &:last-child {
    left: 60px;
    top: 0;
    z-index: 2;
  }
`;
